import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    name: "Solid Men Mandarin Collar White, Blue T-Shirt",
    company: "FastColors",
    category:'Kids',
    price: "2940", 
    rating: "3",
    inStock: true,
    imageURL: "https://images.unsplash.com/photo-1613852348851-df1739db8201?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFuJTIwdCUyMHNoaXJ0fGVufDB8MXwwfHw%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    _id: uuid(),
    name: "Solid Men Mandarin Collar White, Blue T-Shirt",
    company: "FastColors",
    category:'Men',
    price: "3000",
    rating: "2",
    inStock: true,
    imageURL: "https://images.unsplash.com/photo-1617127365659-c47fa864d8bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDJ8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    _id: uuid(),
    name: "Solid Men Mandarin Collar White, Blue T-Shirt",
    company: "FastColors",
    category:'Men',
    price: "3500",
    rating: "4",
    inStock: false,
    imageURL: "https://images.unsplash.com/photo-1617137984095-74e4e5e3613f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
  {
    _id: uuid(),
    name: "Solid Men Mandarin Collar White, Blue T-Shirt",
    company: "FastColors",
    category:'Kids',
    price: "1940",
    rating: "5",
    inStock: false,
    imageURL: "https://images.unsplash.com/photo-1618354691229-88d47f285158?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=415&q=80",
  },
  {
    _id: uuid(),
    name: "Solid Men Mandarin Collar White, Blue T-Shirt",
    company: "FastColors",
    category:'Kids',
    price: "5000",
    rating: "1",
    inStock: true,
    imageURL: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=580&q=80",
  },
  {
    _id: uuid(),
    name: "Solid Men Mandarin Collar White, Blue T-Shirt",
    company: "FastColors",
    category:'Women',
    price: "2500",
    rating: "2",
    inStock: false,
    imageURL: "https://images.unsplash.com/photo-1573742262768-2693bc5b65e1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
  },
  {
    _id: uuid(),
    name: "Solid Men Mandarin Collar White, Blue T-Shirt",
    company: "FastColors",
    category:'Women',
    price: "8990",
    rating: "5",
    inStock: true,
    imageURL: "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1620339026-best-amazon-dresses-for-women-floral-maxi-1620338999.png",
  },
  {
    _id: uuid(),
    name: "Solid Men Mandarin Collar White, Blue T-Shirt",
    company: "FastColors",
    category:'Women',
    price: "1200",
    rating: "4",
    inStock: true,
    imageURL: "https://cdn.shopify.com/s/files/1/0486/0634/7416/files/Livin.png?v=1641231363",
  },
  {
    _id: uuid(),
    name: "Solid Men Mandarin Collar White, Blue T-Shirt",
    company: "FastColors",
    category:'Men',
    price: "699",
    rating: "3",
    inStock: true,
    imageURL: "https://www.suitsexpert.com/wp-content/uploads/2020/01/mens-smart-casual-dress-code-example.jpg",
  },
  {
    _id: uuid(),
    name: "Solid Men Mandarin Collar White, Blue T-Shirt",
    company: "FastColors",
    category:'Kids',
    price: "1500",
    rating: "2",
    inStock: true,
    imageURL: "https://images.unsplash.com/photo-1584370848010-d7fe6bc767ec?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTZ8fGplYW5zfGVufDB8MXwwfHw%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    _id: uuid(),
    name: "Solid Men Mandarin Collar White, Blue T-Shirt",
    company: "FastColors",
    category:'Women',
    price: "5990",
    rating: "1",
    inStock: true,
    imageURL: "https://images.unsplash.com/photo-1578100596537-e1ff0ca79904?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzl8fHdvbWVuJTIwY2xvdGhlc3xlbnwwfDF8MHx8&auto=format&fit=crop&w=500&q=60",
  },
  {
    _id: uuid(),
    name: "Solid Men Mandarin Collar White, Blue T-Shirt",
    company: "FastColors",
    category:'Women',
    price: "4000",
    rating: "1",
    inStock: true,
    imageURL: "https://images.unsplash.com/photo-1532453288672-3a27e9be9efd?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=464&q=80",
  },
];
